import { postRequest } from '.';
import { GradeData, ReceiptGradeType } from '/types/index';
import { PRODUCT_CONDITION_TYPES, RECEIPT_GRADE_TYPES } from 'utils/constants';

const getReceiptGrade = (gradeData: GradeData): ReceiptGradeType | null => {
  if (
    gradeData.is_new === true &&
    gradeData.product_condition === PRODUCT_CONDITION_TYPES.HAS_PACKAGING
  )
    return RECEIPT_GRADE_TYPES.NIB;
  if (
    gradeData.is_new === true &&
    gradeData.product_condition === PRODUCT_CONDITION_TYPES.NO_PACKAGING
  )
    return RECEIPT_GRADE_TYPES.NOB;
  if (gradeData.is_new === false && gradeData.product_condition === PRODUCT_CONDITION_TYPES.USABLE)
    return RECEIPT_GRADE_TYPES.USABLE;
  if (
    gradeData.is_new === false &&
    gradeData.product_condition === PRODUCT_CONDITION_TYPES.UNUSABLE
  )
    return RECEIPT_GRADE_TYPES.SALVAGE;
  return null;
};

export const gradeItem = async (gradeData: GradeData, isRejected?: boolean) => {
  const receipt_grade = isRejected ? 'reject' : getReceiptGrade(gradeData);
  const payload = {
    transaction_id: gradeData.transaction_id,
    receipt_line: gradeData.receipt_line ?? 0,
    receipt_grade: receipt_grade,
    upc: gradeData.upc,
    vendor_id: gradeData.vendor_id ?? null,
    exception_process: gradeData.exception_process ?? 'none',
    disposition_stage: gradeData.disposition_stage ?? '',
    user_id: gradeData.user_id,
    station_id: gradeData.station_id,
  };
  return postRequest('receipt-graded-line', payload);
};

export const startGrading = async (trackingId: string, userId: string, stationId: string) => {
  return postRequest('receipt-graded-start', {
    tracking_id: trackingId,
    user_id: userId,
    station_id: stationId,
  });
};

export const addProduct = async (gradeData: GradeData) => {
  const receipt_grade = getReceiptGrade(gradeData);
  const payload = {
    transaction_id: gradeData.transaction_id,
    receipt_line: gradeData.receipt_line ?? 0,
    receipt_grade: receipt_grade,
    upc: gradeData.upc,
    vendor_id: gradeData.vendor_id ?? null,
    exception_process: gradeData.exception_process ?? 'none',
    disposition_stage: gradeData.disposition_stage ?? '',
    user_id: gradeData.user_id,
    station_id: gradeData.station_id,
  };
  return postRequest('rpass-receipt-graded-add-product-ui', payload);
};

export const isGradingAllowedToday = async () => {
  // return postRequest('', {}); // TODO: Add correct endpoint and payload
  return true;
};
